// extracted by mini-css-extract-plugin
export default {"listingSkeleton":"listingSkeleton_listingSkeleton__3vIIQ","list":"listingSkeleton_list__Lln5k"};